import { render, staticRenderFns } from "./SendOrderingLinkButton.vue?vue&type=template&id=720cfdc5&"
import script from "./SendOrderingLinkButton.vue?vue&type=script&lang=ts&"
export * from "./SendOrderingLinkButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports